<template>
  <div id="navbar" class="bg-navbar">
    <div class="content mx-auto p-0">
      <b-navbar toggleable="sm" type="dark" class="bg-navbar m-0 px-0 py-1">
        <b-navbar-brand to="/home">
          <div v-if="personalize">{{ currentUser.name }}'s Drills</div>
          <div v-else>My Drills</div>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item-dropdown text="Math">
              <b-dropdown-item to="/math-facts">Math Facts</b-dropdown-item>
              <b-dropdown-item to="/arithmetic">Arithmetic</b-dropdown-item>
              <b-dropdown-item to="/pre-algebra">Pre-algebra</b-dropdown-item>
              <b-dropdown-item to="/algebra">Algebra</b-dropdown-item>
            </b-nav-item-dropdown>
            <!-- BEGIN TESTING
            <b-nav-item-dropdown text="EP Math">
              <b-dropdown-item to="/ep-algebra-1/quizzes">EP Algebra 1 Quizzes</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item to="/ep-geometry/quizzes">EP Geometry Quizzes</b-dropdown-item>
              <b-dropdown-item to="/ep-geometry/theorems">EP Geometry Theorems</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item to="/ep-algebra-2/quizzes">EP Algebra 2 Quizzes</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item to="/sat-math">SAT Math</b-nav-item>
            END TESTING -->
            <b-nav-item-dropdown text="Languages">
              <b-dropdown-item to="/spanish">Spanish</b-dropdown-item>
              <b-dropdown-item to="/korean">Korean</b-dropdown-item>
              <b-dropdown-item to="/french">French</b-dropdown-item>
            </b-nav-item-dropdown>
            <!--
            <b-nav-item to="/apps">Apps</b-nav-item>
            -->
            <b-nav-item to="/books">Books</b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto mr-2">
            <b-nav-item-dropdown :text="currentUser.name" class="mt-1">
              <b-dropdown-item v-for="user in allUsers" :key="user.id"
                @click.prevent="switchUser(user)">{{ user.name }}</b-dropdown-item>
              <b-dropdown-item to="/settings">Add ...</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item to="/settings" title="Settings"><SvgIcon name="config" variant="light" /></b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div :style="'height: 10px; background-color: ' + currentUser.color"></div>
  </div>
</template>

<script>
import * as Store from '@/common/js/store.js'

import SvgIcon from '@/common/SvgIcon.vue'

export default {
  name: 'Navbar',
  components: {
    SvgIcon
  },
  data () {
    return {
      currentUser: null,
      allUsers: null
    }
  },
  created: function () {
    this.currentUser = Store.userRecord.current()
    this.allUsers = Store.userRecord.all()
  },
  computed: {
    personalize: function () {
      return !Store.userRecord.isDefault(this.currentUser)
    }
  },
  methods: {
    switchUser (user) {
      if (user.id === this.currentUser.id) return false

      Store.userRecord.updateCurrent(user)
      this.currentUser = Store.userRecord.current()

      this.$router.go()
    }
  }
}
</script>

<style scoped>
.bg-navbar {
  background-color: #17a2b8;
}
</style>



// WEBPACK FOOTER //
// src/common/Navbar.vue